
interface LocaleType {
  [key:string]: any
}

const zh_CN:LocaleType = {
  copy: {
    successMessage: '复制成功'
  },
  cleanUp: '清除',
  noData: '暂无数据',
  total: '共',
  item: '条',
  customListFields: '自定义列表字段',
  selectItem: '请选择您想显示的列表详细信息。您已勾选'
}

export default zh_CN